module.exports = __webpack_public_path__ + "media/src/images/logos/partners/arise-891531c7d41a270fcd0b3372b306e9e0.svg";